import { getLayer } from '../layerService.js';

export default class ObjectCreateCommand {
    constructor({ objectUuid, config, pageHaspId, pageUuid }) {
        this.id = crypto.randomUUID();
        this.timestamp = Date.now();
        this.description = 'Add ' + (config.obj ?? 'object');
        this.category = 'structure';
        this.objectUuid = objectUuid;
        this.affectedUuids = [objectUuid];
        this.pageUuid = pageUuid ?? null;
        // Embed UUID so importObject recreates with the same identity
        this.config = { ...config, _uuid: objectUuid };
        this.pageHaspId = pageHaspId;
    }

    execute() {
        const layer = getLayer();
        if (!layer) return;
        const page = layer.findPage(this.pageHaspId);
        if (page) layer.switchToPage(page);
        layer.importObject({ ...this.config });
        layer.batchDraw();
    }

    undo() {
        const layer = getLayer();
        if (!layer) return;
        const node = layer.findOne('#' + this.objectUuid);
        if (node) {
            // Clear transformer before destroying to avoid dangling references
            if (layer.transformer?.nodes().includes(node)) {
                layer.transformer.nodes([]);
            }
            node.destroy();
            layer.haspobject = layer.activePage;
            layer.batchDraw();
        }
    }

    toJSON() {
        return {
            type: 'ObjectCreate',
            id: this.id,
            timestamp: this.timestamp,
            payload: { objectUuid: this.objectUuid, config: this.config, pageHaspId: this.pageHaspId },
        };
    }
}
